export default {
      id: "chevronUp-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#chevronUp-usage",
      toString: function () {
        return this.url;
      }
    }